import React, { useState } from 'react'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import CheckIcon from 'components/material-symbol/icons/Check'
import SubviewPageHeader from 'pages/pga-coach/bookings/events/event-details-dialog/subview-page-header'
import RecordBookingPaymentForm from 'components/record-booking-payment-form'
import RecordBookingPaymentParticipantSummary from 'components/record-booking-payment-dialog/participant-summary'
import { useStyles } from './styles'

const FORM_ID = 'record-booking-payment-form-session-subview'

const PaidOfflineSubview = ({
  enrollment,
  lessonType,
  eventTitle,
  eventDate,
  participantName,
  onBack,
  onPaymentSuccess,
}) => {
  const classes = useStyles()
  const [isChargeMode, setIsChargeMode] = useState(false)

  const handlePaymentSuccess = () => {
    onPaymentSuccess?.()
    onBack()
  }

  const handleBack = () => {
    setIsChargeMode(false)
    onBack()
  }

  return (
    <Box className={classes.editSessionRoot}>
      <SubviewPageHeader pageTitle="Paid Offline" onBack={handleBack} />
      <Box className={classes.paidOfflineIntroSection}>
        <Typography component="div" className={classes.editSessionHelper}>
          Record how this student paid for the session.
        </Typography>
        <RecordBookingPaymentParticipantSummary
          participantName={participantName}
          eventTitle={eventTitle}
          eventDate={eventDate}
          dividerClassName={classes.paidOfflineDivider}
        />
      </Box>
      <RecordBookingPaymentForm
        formId={FORM_ID}
        enrollment={enrollment}
        defaultAmountInCents={lessonType.priceInCents}
        acceptOnlinePayments={lessonType.acceptsOnlinePayments}
        onChargeModeChange={setIsChargeMode}
        onPaymentSuccess={handlePaymentSuccess}
      />
      {!isChargeMode ? (
        <Box className={classes.editSessionActions}>
          <Button color="primary" size="large" onClick={handleBack}>
            Cancel
          </Button>
          <Button
            color="primary"
            variant="contained"
            size="large"
            disableElevation
            startIcon={<CheckIcon fontSize="small" />}
            type="submit"
            form={FORM_ID}
          >
            Save
          </Button>
        </Box>
      ) : null}
    </Box>
  )
}

export default PaidOfflineSubview
